module.exports = __webpack_public_path__ + "img/settings_blue.341724d7.svg";